import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Edge, Node } from '@swimlane/ngx-graph';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';

import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { MainService } from '../main.service';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import Swal from 'sweetalert2';

interface HierNode {
  id: number;
  code: string;
  cur_tr: string;
  name: string;
  children?: HierNode[];
  isRoot: boolean;
  cur_par_id: any;
  cur_par_tr: string;
  cur_par_val: string;
  hier_cl_id: number;
}

declare module '@swimlane/ngx-graph' {
  interface Node {
    id1: number; // Assuming id1 is of type number
  }
}

@Component({
  selector: 'lib-hierarchy-management',
  templateUrl: './hierarchy-management.component.html',
  styleUrls: ['./hierarchy-management.component.css']
})
export class HierarchyManagementComponent implements OnInit {

  data = [];
  TREE_DATA: HierNode[] = [];
  hierarchyNodes: any[] = [];
  // treeControl = new NestedTreeControl<HierNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<HierNode>();
  selectedNode: HierNode | null = null;
  hierarchyName: string = '';
  hierarchyTermName: string = '';
  hierarchyLeafCd: any[] = [];
  nonMatchingValues: any[] = [];
  showModal: boolean = false;
  newClassificationCode: string = '';
  newClassificationValue: string = '';
  selectedType: string = 'HIER';
  parentName: string = '';
  showAddParentForm: boolean = false;
  terms: any[] = [];
  termsData: any[] = [];
  classifications: any[] = [];
  classificationsData: any[] = [];
  selectedTerm: any;
  selectedClassification = '';
  currentNode: any = {};
  whereFrom: string = '';
  classificationFilter: string = '';
  filterText: string = '';
  classificationsDataArray: any[] = [];
  hierarchyAllNodes: any[] = [];
  unattachedClassifications: any[] = [];

  showGraph: boolean = false;
  nodes: Node[] = [];
  links: Edge[] = [];
  filteredNodes: Node[] = [];
  filteredLinks: Edge[] = [];
  toggledNodes: Set<string> = new Set<string>();
  isVertical: boolean = true;
  layoutSettings: any = {
    orientation: 'TB',  // Top to Bottom
  };

  hierClIdOptions: number[] = [];
  selectedHierClId: number | undefined;
  allHierarchyData: Array<{ cl_id: number, cl_cd: string, cl_desc: string }> = [];
  selectedHierItem: any;
  isDragging = false;
  offsetX: number = 0;
  offsetY: number = 0;
  dragStartTimeout: any;
  treeControl: NestedTreeControl<HierNode>;

  constructor(private mainService: MainService, private route: ActivatedRoute, private location: Location, private cdr: ChangeDetectorRef) {
    this.treeControl = new NestedTreeControl<HierNode>(node => node.children);
    this.dataSource = new MatTreeNestedDataSource<HierNode>();
    this.treeControl.expansionModel.changed.subscribe(change => {
      change.added.forEach(node => this.expandedNodeIds.add(node.id));
      change.removed.forEach(node => this.expandedNodeIds.delete(node.id));
    });
  }
  authobj: any = {}
  erpUser: any = {}
  hasChild = (_: number, node: HierNode) => !!node.children && node.children.length > 0;
  hrconfig: any = {}
  async ngOnInit() {
    let obj: any = this.route.snapshot.queryParamMap.get('id');
    console.log(obj);
    let a = window.atob(obj)
    let b = JSON.parse(a);
    this.hrconfig = b
    this.selectedHierClId = this.hrconfig['cl_id']
    this.hierarchyName=this.hrconfig['cl_val']
    if (sessionStorage.getItem('svm_jwt') && sessionStorage.getItem('erpUser')) {
      let erpUserString = sessionStorage.getItem('erpUser');
      this.erpUser = erpUserString && JSON.parse(erpUserString);

    }

    this.authobj =
    {
      "act_id": this.erpUser?.b_acct_id || 1,
      "jwt": { "uid": this.erpUser?.le_id || 'princy' }
    }


    //  await this.getAllHierarchy();
    await this.getHierarchy();
    await this.getTerms();
  }
  isParentNode(node: any): boolean {
    return !!node.children && node.children.length > 0;
  }

  async getAllHierarchy() {
    let obj = {
      "id": this.authobj,
      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "cl"
      },
      "where": {
        "cl_tcd": "HIER"
      }
    }
    this.mainService.get(obj).subscribe(async (data) => {
      if (data['error'] == false) {
        console.log(data['data']);
        this.allHierarchyData = data['data'];
        this.selectedHierClId = data['data'][0]['cl_id']
        data['data'].forEach((item: any) => {
          this.hierClIdOptions.push(item.cl_id);
        });
      }
    });
  }

  changeHierClId() {
    this.getHierarchy(this.selectedHierClId);
  }

  async getHierarchy(hier_cl_id = this.selectedHierClId) {
    await this.reset()
    // console.log('getHierarchy');
    let obj = {
      "id": {
        "act_id": 1,
        "jwt": {
          "uid": "aishwar"
        }
      },
      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "fh"
      },
      "where": {
        "hier_cl_id": hier_cl_id
      }
    }
    this.mainService.getHierarchy(obj).subscribe(async (data) => {
      if (data['error'] == false) {
        if (data['data'].length > 0) {
          this.hierarchyNodes = data['data'];
          console.log("hierarchyNodes", this.hierarchyNodes);
          this.hierarchyName = this.hierarchyNodes[0]['hier_nm'];
          this.hierarchyTermName = this.hierarchyNodes[0]['hier_tr_nm'];
          // console.log("this.hierarchyTermName", this.hierarchyTermName);
          this.hierarchyLeafCd = [];
          for (let i = 0; i < this.hierarchyNodes.length; i++) {
            if (this.hierarchyNodes[i].hasOwnProperty('leaf_cd') && !this.hierarchyLeafCd.includes(this.hierarchyNodes[i]['leaf_cd'])) {
              this.hierarchyLeafCd.push(this.hierarchyNodes[i]['leaf_cd']);
            }
          }
          await this.getDiData(this.hierarchyNodes[0]['hier_tr_nm']);
        }

      }
   
      // console.log(this.hierarchyNodes[0]['hier_tr_nm']);
    });
  }

  async getDiData(di_tech_nm: string) {
    // console.log('getDiData');
    let obj = {
      "id": {
        "act_id": 1,
        "jwt": {
          "uid": "aishwar"
        }
      },
      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "di"
      },
      "where": {
        "di_tech_nm": di_tech_nm
      }
    }
    this.mainService.getDiData(obj).subscribe(data => {
      if (data['error'] == false) {
        let diData = data['data'];
        // console.log("getDiData", diData);
        // console.log(diData[0]['di_id']);
        this.getClassificationsForTerm(diData[0]['di_id']);
      }
    });
  }
  classificationsDataright: any
  classificationsright: any
  async getClassificationsForrightbox(di_id: number, di_tech_nm?: string) {
    // console.log("getClassificationsForTerm", di_id, di_tech_nm);
    let obj = {
      "id": this.authobj,
      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "cl"
      },
      "where": {
        "di_id": di_id,
        "cl_tcd": "AV"
      }
    }
    this.mainService.getClassificationsForTerm(obj).subscribe(async (data) => {
      if (data['error'] == false) {
        // console.log(data['data'], "getClassificationsForTerm");
        this.classificationsDataright = data['data'];
        // this.classificationsDataArray = [];
        // console.log(this.classificationsData, "this.classificationsData")
        // console.log(this.hierarchyLeafCd, "this.hierarchyLeafCd")
        for (const item of data['data']) {
          // console.log(item);
          this.classificationsright.push(item['cl_cd'])
        }
        if (di_tech_nm) {
          // console.log("with di_tech_nm")
          await this.findNotMatchingClassifications(di_tech_nm);
        } else {
          // console.log("without di_tech_nm")
          await this.findNotMatchingClassifications();
        }
      }
    });
  }

  async getClassificationsForTerm(di_id: number, di_tech_nm?: string) {
    // console.log("getClassificationsForTerm", di_id, di_tech_nm);
    let obj = {
      "id": this.authobj,
      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "cl"
      },
      "where": {
        "di_id": di_id,
        "cl_tcd": "AV"
      }
    }
    this.mainService.getClassificationsForTerm(obj).subscribe(async (data) => {
      if (data['error'] == false) {
        // console.log(data['data'], "getClassificationsForTerm");
        this.classificationsData = data['data'];
        // this.classificationsDataArray = [];
        // console.log(this.classificationsData, "this.classificationsData")
        // console.log(this.hierarchyLeafCd, "this.hierarchyLeafCd")
        for (const item of data['data']) {
          // console.log(item);
          this.classifications.push(item['cl_cd'])
        }
        if (di_tech_nm) {
          // console.log("with di_tech_nm")
          await this.findNotMatchingClassifications(di_tech_nm);
        } else {
          // console.log("without di_tech_nm")
          await this.findNotMatchingClassifications();
        }
      }
    });
  }

  async findNotMatchingClassifications(di_tech_nm?: string) {

    // console.log("di_tech_nm", di_tech_nm);

    // console.log(this.nonMatchingValues, "this.nonMatchingValues");

    // console.log(this.nonMatchingValues, "this.nonMatchingValues");
    // console.log(this.hierarchyNodes, "this.hierarchyNodes");

    // console.log(this.classificationsData, "this.classificationsData");

    if (di_tech_nm) {
      await this.transformDataToTree(this.hierarchyNodes);
    } else {
      await this.transformDataToTree(this.hierarchyNodes);
    }

    for (const node of this.hierarchyNodes) {
      if (node.leaf_cd === node.lvl1_cd) {
        const existingNodeIndex = this.unattachedClassifications.findIndex(item => item.leaf_cd === node.leaf_cd);

        if (existingNodeIndex === -1) {
          this.unattachedClassifications.push(node);
        } else {
          // console.log(`Duplicate leaf_cd found: ${node.leaf_cd}`);
        }
      }
    }

    // console.log("Unattached Classifications:", this.unattachedClassifications);
    // console.log("loop finished");
  }

  async transformDataToTree(data: any) {
    const rootNodes: { [key: string]: HierNode } = {};
    this.nodes = [];
    this.links = [];
    this.hierarchyAllNodes = [];
    this.hierNodes = []
    // console.log("data", data);
    for (const item of data) {
      // console.log("item", item);
      if (!rootNodes[item.lvl1_cd]) {
        const cur_par_id = null;
        const cur_par_tr = '';
        const cur_par_val = '';
        rootNodes[item.lvl1_cd] = { hier_cl_id: item.hier_cl_id, id: item.lvl1_id, code: item.lvl1_cd, cur_tr: item.lvl1_tr_nm, name: item.lvl1_val, children: [], isRoot: true, cur_par_id: cur_par_id, cur_par_tr: cur_par_tr, cur_par_val: cur_par_val };
        // console.log("rootNodes[item.lvl1_cd]", rootNodes[item.lvl1_cd]);
        const newNode = { id: 1 + item.lvl1_cd, label: item.lvl1_val, hier_cl_id: item.hier_cl_id, id1: item.lvl1_id, code: item.lvl1_cd, cur_tr: item.lvl1_tr_nm, name: item.lvl1_val, children: [], isRoot: true, cur_par_id: cur_par_id, cur_par_tr: cur_par_tr, cur_par_val: cur_par_val };

        const existingNodeIndex = this.nodes.findIndex(node => node.id1 === newNode.id1 && node['label'] === newNode.label);

        if (existingNodeIndex !== -1) {
          this.nodes.splice(existingNodeIndex, 1);
        }

        this.nodes.push(newNode);
        this.hierarchyAllNodes.push(item.lvl1_id)
      }
    }

    for (const item of data) {

      this.filteredNodes = [];
      this.filteredLinks = [];

      let parentNode = rootNodes[item.lvl1_cd];
      // console.log("parentNode", parentNode);
      let currentLevel = 2;

      while (currentLevel <= 20) {

        // console.log("this.nodes", this.nodes)

        this.filteredNodes = [...this.nodes];
        this.filteredLinks = [...this.links];

        // console.log("this.filteredNodes", this.filteredNodes);
        // console.log("this.filteredLinks", this.filteredLinks);

        const childNodeId = item[`lvl${currentLevel}_id`];
        const childNodeCode = item[`lvl${currentLevel}_cd`];
        const childNodeName = item[`lvl${currentLevel}_val`];
        // console.log("childNodeName", childNodeName);        

        if (childNodeName) {
          let childNode = parentNode.children && parentNode.children.find(child => child.name === childNodeName);
          // console.log("childNode", childNode);
          if (!childNode) {

            const cl_id = 0;
            const cur_tr = currentLevel === 2 ? item[`lvl${currentLevel}_tr_nm`] : item[`lvl${currentLevel}_tr_nm`];
            const cur_par_id = currentLevel === 2 ? item.lvl1_id : item[`lvl${currentLevel - 1}_id`];
            const cur_par_tr = currentLevel === 2 ? item.lvl1_tr_nm : item[`lvl${currentLevel - 1}_tr_nm`];
            const cur_par_val = currentLevel === 2 ? item.lvl1_val : item[`lvl${currentLevel - 1}_val`];
            childNode = { hier_cl_id: item.hier_cl_id, id: childNodeId, code: childNodeCode, cur_tr: cur_tr, name: childNodeName, children: [], isRoot: false, cur_par_id: cur_par_id, cur_par_tr: cur_par_tr, cur_par_val: cur_par_val };
            // console.log("childNode1", childNode);
            parentNode.children && parentNode.children.push(childNode);
            // console.log("parentNode1", parentNode);

            const newNode = { id: currentLevel + item[`lvl${currentLevel}_cd`], label: item[`lvl${currentLevel}_val`], hier_cl_id: item.hier_cl_id, id1: childNodeId, code: childNodeCode, cur_tr: cur_tr, name: childNodeName, children: [], isRoot: false, cur_par_id: cur_par_id, cur_par_tr: cur_par_tr, cur_par_val: cur_par_val };

            const existingNodeIndex = this.nodes.findIndex(node => node.id1 === newNode.id1 && node['label'] === newNode.label);

            if (existingNodeIndex !== -1) {
              this.nodes.splice(existingNodeIndex, 1);
            }

            this.nodes.push(newNode);

            // console.log("nodes", this.nodes);

            const sourceId = currentLevel - 1 + item[`lvl${currentLevel - 1}_cd`];
            const targetId = currentLevel + item[`lvl${currentLevel}_cd`];

            // console.log("Source ID:", sourceId);
            // console.log("Target ID:", targetId);
            // console.log("Nodes:", this.nodes);

            // Check if the source and target IDs exist in this.nodes
            const sourceExists = this.nodes.some(node => node['id'] === sourceId);
            const targetExists = this.nodes.some(node => node['id'] === targetId);

            // console.log("Source exists:", sourceExists);
            // console.log("Target exists:", targetExists);

            // Log existing links before adding a new one
            // console.log("Existing links:", this.links);

            if (sourceExists && targetExists) {
              const newLink = {
                source: sourceId,
                target: targetId,
                label: item[`lvl${currentLevel}_val`]
              };

              // console.log("New link:", newLink);

              const existingLinkIndex = this.links.findIndex(link => link.target === newLink.target && link.label === newLink.label);

              if (existingLinkIndex !== -1) {
                this.links.splice(existingLinkIndex, 1);
              }

              this.links.push(newLink);

              // console.log("Link added:", newLink);
            }


            this.hierarchyAllNodes.push(item[`lvl${currentLevel}_id`])
          }
          parentNode = childNode;
          // console.log("parentNode2", parentNode);
        } else {
          break;
        }

        currentLevel++;
      }
    }

    // console.log("rootNodes", rootNodes)

    this.TREE_DATA = Object.values(rootNodes);
    // console.log("this.TREE_DATA", this.TREE_DATA);
    let upIndex = this.TREE_DATA.findIndex(node => node.code === 'UP');
    if (upIndex !== -1) {
      // [this.TREE_DATA[0], this.TREE_DATA[upIndex]] = [this.TREE_DATA[upIndex], this.TREE_DATA[0]];
      this.dataSource.data = this.TREE_DATA;
      this.treeControl.dataNodes = this.dataSource.data;
    } else {
      console.log("Hierarchy 'UP' not found, proceeding without it.");
      console.log(this.TREE_DATA);

      this.dataSource.data = this.TREE_DATA;
      this.treeControl.dataNodes = this.dataSource.data;
    }
    this.treeControl.dataNodes.forEach(node => {
      if (this.expandedNodeIds.has(node['id'])) {
        this.treeControl.expand(node);
      }
    });

    // this.dataSource.data = this.TREE_DATA;
    // console.log("this.dataSource.data", this.dataSource.data)
    this.updateFilteredNodesAndLinks();
  }

  showConnectedNodes(nodeIds: string | string[]) {
    console.log("showConnectedNodes", nodeIds);

    const nodeIdArray = Array.isArray(nodeIds) ? nodeIds : [nodeIds];
    const connectedLinks = this.links.filter(link => nodeIdArray.includes(link.source) || nodeIdArray.includes(link.target));

    const parentNodes = new Set<string>();
    connectedLinks.forEach(link => {
      if (nodeIdArray.includes(link.target)) {
        parentNodes.add(link.source);
      }
    });

    const siblingNodes = new Set<string>();
    parentNodes.forEach(parent => {
      this.links.forEach(link => {
        if (link.source === parent && !nodeIdArray.includes(link.target)) {
          siblingNodes.add(link.target);
        }
      });
    });

    const connectedNodeIds = new Set(connectedLinks.flatMap(link => [link.source, link.target]));
    parentNodes.forEach(node => connectedNodeIds.add(node));
    siblingNodes.forEach(node => connectedNodeIds.add(node));

    this.filteredNodes = this.nodes.filter(node => connectedNodeIds.has(node['id']));
    this.filteredLinks = this.links.filter(link =>
      connectedNodeIds.has(link.source) && connectedNodeIds.has(link.target)
    );
  }
  hierNodes: HierNode[] = [];

  async addRootNode(classification: any) {
    // console.log(classification.cl_cd);
    const newNode: HierNode = {
      id: classification.cl_id,
      code: classification.cl_cd,
      name: classification.cl_val,
      children: [],
      isRoot: true,
      cur_tr: '',
      cur_par_id: 0,
      cur_par_tr: '',
      cur_par_val: '',
      hier_cl_id: this.hierarchyNodes[0]['hier_cl_id']
    };

    this.TREE_DATA.push(newNode);
    this.dataSource.data = this.TREE_DATA;
    // this.hierNodes.push(newNode);
    // this.dataSource.data = this.hierNodes;
  }

  setSelectedNode(node: any) {
    this.selectedNode = node;
    // console.log("selectedNode", this.selectedNode);
  }

  toggleAddParentForm(node: any) {
    // console.log(node);
    this.showAddParentForm = !this.showAddParentForm;
    // this.getTerms();
    // this.toggleModal();
  }

  async getTerms() {
    // console.log('getTerms');
    let obj = {
      "id": {
        "act_id": 1,
        "jwt": {
          "uid": "aishwar"
        }
      },
      "operation": "find",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "di"
      }
    }
    this.mainService.getTerms(obj).subscribe(data => {
      if (data['error'] == false) {
        let items: any = data['data'];
        // console.log("items", items);

        items = items.filter((item: any) => item.di_tcd_json && item.di_tcd_json.cl_type);

        this.termsData = items;

        for (const item of items) {
          // console.log("item", item);
          this.terms.push(item['di_tech_nm']);
        }
      }
    });
  }
  clarr = []
  async onTermChange() {
    this.classifications = [];
    this.classificationsData = [];
    // const selectedValue = (event.target as HTMLSelectElement).value;
    // this.selectedTerm = (event.target as HTMLSelectElement).value;
    // console.log('Selected Term:', selectedValue);
    // console.log("this.dataSource.data", this.dataSource.data)
    for (const item of this.termsData) {
      if (item['di_tech_nm'] == this.selectedTerm) {
        // console.log('Terms Data:', item);
        this.getClassificationsForrightbox(item['di_id'], item['di_tech_nm']);
        break;
      }
    }



    // console.log(clarr);

  }

  onValueChange(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    // console.log('Selected Term:', selectedValue);
    // console.log("this.dataSource.data", this.dataSource.data)
    for (const item of this.classificationsData) {
      if (item['cl_cd'] == selectedValue) {
        // this.selectedNode!.id = item['cl_id'];
      }
    }
  }

  filterClassifications() {
    let nonMatchingObjects: any[] = [];
    // console.log("this.hierarchyAllNodes", this.hierarchyAllNodes);
    // console.log("this.classificationsData", this.classificationsData);
    // console.log("Unattached Classifications:", this.unattachedClassifications);

    this.classificationsDataright.forEach(obj => {
      // console.log("obj", obj);
      if (!this.hierarchyAllNodes.includes(obj.cl_id)) {
        nonMatchingObjects.push(obj);
      }
    });

    this.classificationsDataright.forEach(obj => {
      const isMatched = this.unattachedClassifications
        .some(unattachedObj => unattachedObj.leaf_cd === obj.cl_cd && unattachedObj.leaf_val === obj.cl_val);
      if (isMatched) {
        nonMatchingObjects.push(obj);
      }
    });

    const uniqueNonMatchingObjects = nonMatchingObjects.filter((obj, index, self) =>
      index === self.findIndex((t) => (
        t.cl_val === obj.cl_val && t.cl_cd === obj.cl_cd
      ))
    );

    // console.log("nonMatchingObjects", nonMatchingObjects);
    // console.log("nonMatchingObjects after removing duplicates", uniqueNonMatchingObjects);

    if (!uniqueNonMatchingObjects) return [];
    if (!this.filterText) return uniqueNonMatchingObjects;
    const searchText = this.filterText.toLowerCase();
    return uniqueNonMatchingObjects.filter(item => {
      return item.cl_val.toLowerCase().includes(searchText) || item.cl_cd.toLowerCase().includes(searchText);
    });
  }

  async unattachFromParent(node: any, whereFrom: string) {
    console.log("unattachFromParent", node);
    Swal.fire({
      title: `Do you want to remove ${node.name}`,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire('Saved!', '', 'success')
        await this.destroyHierarchy(node, whereFrom);
        await this.getHierarchy();
        this.currentNode = {};
        this.unattachedClassifications = [];
        Swal.fire('Saved!', '', 'success');
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    })
  }

  onDragStart(node: any, whereFrom: string) {
    this.whereFrom = whereFrom;
    console.log("onDragStart", node);
    console.log("whereFrom", whereFrom);
    if (node && node.hasOwnProperty('cl_tcd')) {
      // console.log("onDragStart if");
      this.currentNode['id'] = node['cl_id'];
      this.currentNode['code'] = node['cl_cd'];
      this.currentNode['name'] = node['cl_val'];
    } else {
      // console.log("onDragStart else");
      if (Object.keys(this.currentNode).length === 0) {
        this.currentNode = node;
        // console.log("onDragStart", this.currentNode);
      }
    }
  }

  async destroyHierarchy(currentNode: any, whereTo: string) {

    // console.log("destroyHierarchy1", this.filteredNodes);
    // console.log("destroyHierarchy2", currentNode);
    // console.log("destroyHierarchy3", whereTo);

    let currentNodeId;
    if (whereTo == 'graph') {
      currentNodeId = currentNode.id1;
    } else {
      currentNodeId = currentNode.id;
    }
    let obj = {
      "id": this.authobj,
      "operation": "destroy",
      "app_cd": "DD",
      "into": {
        "schema": "dd",
        "table": "rh"
      },
      "where": { "hier_cl_id": currentNode.hier_cl_id, "sub_cl_id": currentNode.cur_par_id, "obj_cl_id": currentNodeId }
    }

    console.log(obj);

    this.mainService.destroyHierarchy(obj).subscribe(async data => {
      if (data['error'] == false) {
        // console.log(data['data'], "no error");
        await this.getHierarchy();

      }
    });
  }
  async deleteclassification(node: any, whereTo: string) {

    Swal.fire({
      title: `Do you want to delete this  ${node.name} as a classification`,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!node['isRoot']) {
          await this.destroyHierarchy(node, whereTo)
        }
        await this.deleteclassificationfinal(node['id'])

        Swal.fire('Saved!', '', 'success');
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
      }
    })
  }
  async deleteclassificationfinal(cl_id: any) {
    let obj = {
      "id": this.authobj,
      "operation": "destroy",
      "app_cd": "DD",
      "into": {
        "schema": "dd",
        "table": "cl"
      },
      "where": { "cl_id": cl_id }
    }

    console.log(obj);

    this.mainService.destroyHierarchy(obj).subscribe(async data => {
      if (data['error'] == false) {
        // console.log(data['data'], "no error");
        this.getHierarchy();

      }
    });
  }
  expandedNodeIds: Set<any> = new Set<any>();

  currentNodeDummy = {}
  onDroppre(event: any, node: any, whereTo: string) {
    console.log("onDrop1", this.currentNode);
    console.log("onDrop2", node);
    console.log("event", event);

    console.log("onDrop - Current Node:", this.currentNode.id);
    console.log("onDrop - Target Node:", node?.id);
    console.log("onDrop - Event:", event);

    if (this.currentNode?.id === node?.id) {
      return;
    }

    Swal.fire({
      title: `Do you want to move ${this.currentNode?.name} into ${node?.name}`,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        event.preventDefault();
        if (this.whereFrom == 'hierarchy') {
          // console.log("this.currentNode", this.currentNode);
          await this.destroyHierarchy(this.currentNode, whereTo);
        }
        console.log("node", node);
        let ondropNodeId;
        if (whereTo == 'hierarchy') {
          ondropNodeId = node['id'];
        } else if (whereTo == 'graph') {
          ondropNodeId = node.id1;
        }

        let obj = {
          "id": {
            "act_id": 1,
            "jwt": { "uid": "aishwar" }
          },
          "operation": "find",
          "app_cd": "DD",
          "from": {
            "schema": "dd",
            "table": "rh"
          },
          "where": {
            "hier_cl_id": node.hier_cl_id, "sub_cl_id": ondropNodeId, "obj_cl_id": this.currentNode.id
          },
          "paranoid": false
        }

        console.log("object for onDropFindIfNodeExists", obj);
        this.mainService.get(obj).subscribe(async (data) => {
          if (data['error'] == false && data['data'].length > 0) {
            console.log("updateHierarchy");
            await this.updateHierarchy(node, whereTo);
          } else if (data['error'] == false && data['data'].length == 0) {
            console.log("insertHierarchy");

            await this.insertHierarchy(node, whereTo);
          } else {
            console.log(data, 'paranoid')
            Swal.fire('Error!', '', 'error');
          }
        });



      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
        event.preventDefault();
        await this.reset()

        // this.currentNode = {};
        // this.unattachedClassifications = [];
      }
    })
  }
  onDrop(event: any, node: any, whereTo: string) {
    console.log("onDrop1", this.currentNode);
    console.log("onDrop2", node);
    console.log("event", event);

    if (!node) {
      // If the node is undefined, it means the item was dropped on the canvas (outside the tree)
      Swal.fire({
        title: `Do you want to add ${this.currentNode.name} at level 1?`,
        showDenyButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          event.preventDefault();

          // Add the node at level 1 (root) in the tree
          let defaultNode = {
            hier_cl_id: this.selectedHierClId,
            id: null
          }
          await this.addNodesToHierarchy(defaultNode, whereTo)

          Swal.fire('Node added at level 1!', '', 'success');
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', '', 'info');
        }
      });
      return;
    }

    if (this.currentNode.id === node['id']) {
      return;
    }

    Swal.fire({
      title: `Do you want to move ${this.currentNode.name} into ${node.name}?`,
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        event.preventDefault();
        await this.addNodesToHierarchy(node, whereTo)

      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info');
        event.preventDefault();
        await this.reset();
      }
    });
  }
  async addNodesToHierarchy1(node: any, whereTo: any) {
    if (this.whereFrom == 'hierarchy') {
      await this.destroyHierarchy(this.currentNode, whereTo);
    }

    let ondropNodeId;
    if (whereTo == 'hierarchy') {
      ondropNodeId = node['id'];
    } else if (whereTo == 'graph') {
      ondropNodeId = node.id1;
    }
    else if (whereTo == 'canvas') {
      ondropNodeId = null;
    }

    let obj = {
      "id": { "act_id": 1, "jwt": { "uid": "aishwar" } },
      "operation": "find",
      "app_cd": "DD",
      "from": { "schema": "dd", "table": "rh" },
      "where": {
        "hier_cl_id": this.selectedHierClId, "sub_cl_id": ondropNodeId, "obj_cl_id": this.currentNode.id
      },
      "paranoid": false
    };

    this.mainService.get(obj).subscribe(async (data) => {
      if (data['error'] == false && data['data'].length > 0) {
        await this.updateHierarchy(node, whereTo);
      } else if (data['error'] == false && data['data'].length == 0) {
        await this.insertHierarchy(node, whereTo);
      } else {
        Swal.fire('Error!', '', 'error');
      }
    });

  }
  async addNodesToHierarchy(node: any, whereTo: any) {
    if (this.whereFrom == 'hierarchy') {
      //await this.updateHierarchy(node, whereTo);
      let ondropNodeId;
      if (whereTo == 'hierarchy') {
        ondropNodeId = node['id'];
      } else if (whereTo == 'graph') {
        ondropNodeId = node.id1;
      }
      else if (whereTo == 'canvas') {
        ondropNodeId = null;
      }

      let obj = {
        "id": { "act_id": 1, "jwt": { "uid": "aishwar" } },
        "operation": "find",
        "app_cd": "DD",
        "from": { "schema": "dd", "table": "rh" },
        "where": {
          "hier_cl_id": this.selectedHierClId, "sub_cl_id": this.currentNode['cur_par_id'], "obj_cl_id": this.currentNode.id
        },
        "paranoid": false
      };

      this.mainService.get(obj).subscribe(async (data) => {
        if (data['error'] == false && data['data'].length > 0) {
          await this.updateHierarchy(node, whereTo);
        } else if (data['error'] == false && data['data'].length == 0) {
          await this.insertHierarchy(node, whereTo);
        } else {
          Swal.fire('Error!', '', 'error');
        }
      });
    }
    else if (this.whereFrom == 'rightbox') {
      await this.insertHierarchy(node, whereTo);
    }


  }

  // Method to handle adding a node at level 1 (root)
  async addAtLevel1(node: any) {
    console.log(this.currentNode);



    // Add the node to your data structure representing the tree's root level


    // Optionally save this change in your backend if required
  }

  async reset() {
    //  await this.findNotMatchingClassifications();
    this.currentNode = {};
    // this.unattachedClassifications = [];
    // this.selectedTerm = null
    await this.onTermChange()
    //  await this.filterClassifications()
    //  this.cdr.detectChanges();
  }

  async insertHierarchy(onDropNode: any, whereTo: string) {
    // console.log("insertHierarchy1", onDropNode);
    // console.log("insertHierarchy2", this.currentNode);
    // console.log("this.filteredNodes", this.filteredNodes);
    let ondropNodeId;

    if (whereTo == 'hierarchy') {
      ondropNodeId = onDropNode.id;
    } else if (whereTo == 'graph') {
      ondropNodeId = onDropNode.id1;
    }
    else if (whereTo == 'canvas') {
      ondropNodeId = null;
    }

    // const nodeFound = this.filteredNodes.find(node => node['id'].includes(this.currentNode.code) && node['id'] !== onDropNode.id);
    // console.log("node", nodeFound);
    // this.filteredNodes = this.filteredNodes.filter(node => node['id'] !== nodeFound?.id);
    // console.log("this.filteredNodes", this.filteredNodes);

    let obj = {
      "id": this.authobj,
      "operation": "insert",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "rh"
      },
      "columns": ["hier_cl_id", "sub_cl_id", "obj_cl_id", "clxcl_tcd", "clxcl_tcd_json"],
      "values": [onDropNode.hier_cl_id, ondropNodeId, this.currentNode.id, "RH", {}]
    }

    console.log("onkect", obj);
    try {
      const data = await this.mainService.insert(obj).toPromise();
      // console.log("data", data);
      if (data['error'] === false) {
        console.log("no error", data['data']);
        Swal.fire('Saved!', '', 'success');
        this.getHierarchy();
      } else {
        console.log("error", data['data']);
        Swal.fire('Error!', data['data']?.['message'], 'error');
      }
    } catch (error) {
      console.error("Error occurred:", error);
      if (error instanceof HttpErrorResponse) {
        const errorCode = error.error?.data?.message?.original?.code;
        console.log("errorCode", errorCode);
        let errmsg = error.error?.data?.message
        if (errorCode === 'ER_DUP_ENTRY') {
          Swal.fire('Error!', errmsg, 'error');
        } else {
          Swal.fire('Error!', errmsg, 'error');
        }
      } else {
        Swal.fire('Error!', '', 'error');
      }
    }
  }

  async updateHierarchy(onDropNode: any, whereTo: string) {
    // console.log("insertHierarchy1", onDropNode);
    // console.log("insertHierarchy2", this.currentNode);
    // console.log("this.filteredNodes", this.filteredNodes);
    let ondropNodeId;

    if (whereTo == 'hierarchy') {
      ondropNodeId = onDropNode.id;
    } else if (whereTo == 'graph') {
      ondropNodeId = onDropNode.id1;
    }
    else if (whereTo == 'canvas') {
      ondropNodeId = null;
    }

    // const nodeFound = this.filteredNodes.find(node => node['id'].includes(this.currentNode.code) && node['id'] !== onDropNode.id);
    // console.log("node", nodeFound);
    // this.filteredNodes = this.filteredNodes.filter(node => node['id'] !== nodeFound?.id);
    // console.log("this.filteredNodes", this.filteredNodes);

    let obj = {
      "id": this.authobj,
      "operation": "update",
      "app_cd": "DD",
      "into": {
        "schema": "dd",
        "table": "rh"
      },
      "where": {
        "hier_cl_id": onDropNode.hier_cl_id, "sub_cl_id": this.currentNode['cur_par_id'], "obj_cl_id": this.currentNode.id, "deleted_at": { "is": null }
      },
      "set": { "hier_cl_id": onDropNode.hier_cl_id, "sub_cl_id": ondropNodeId, "obj_cl_id": this.currentNode.id }
    }

    console.log("onkect", obj);
    try {
      const data = await this.mainService.update(obj).toPromise();
      console.log("data", data);
      if (data['error'] === false) {
        console.log("no error", data['data']);
        Swal.fire('Updated!', '', 'success');
        this.getHierarchy();
      } else {
        // console.log("error", data['data']);
        Swal.fire('Not Updated!', '', 'error');
      }
    } catch (error) {
      console.error("Error occurred:", error);
      if (error instanceof HttpErrorResponse) {
        const errorCode = error.error?.data?.message?.original?.code;
        let errmsg = error.error?.data?.message
        console.log("errorCode", errorCode);
        if (errorCode === 'ER_DUP_ENTRY') {
          Swal.fire('Error!', 'Duplicate entry detected!', 'error');
        } else {
          Swal.fire('Error!', errmsg, 'error');
        }
      } else {
        Swal.fire('Error!', 'error', 'error');
      }
    }
  }

  getFilteredNodes() {
    return this.filteredNodes;
  }

  getFilteredLinks() {
    return this.filteredLinks;
  }

  onDragOver(event: any) {
    console.log("onDragOver");
    event.preventDefault();
  }

  async toggleView() {
    // console.log("toggleView", this.filteredNodes);

    // console.log("this.nodes", this.nodes);
    // console.log("this.links", this.links);
    this.showGraph = !this.showGraph;

    // Clear the toggled nodes
    this.toggledNodes.clear();

    // Toggle all nodes to show/hide them
    this.nodes.forEach(node => {
      if (!this.links.some(link => link.target === node['id'])) {
        // If it's a root node, add it to toggledNodes
        this.toggledNodes.add(node['id']);
      }
    });

    // Update the view to show only the toggled nodes and their children
    this.updateFilteredNodesAndLinks();
  }

  toggleConnectedNodes(nodeIds: string | string[]) {
    const nodeIdArray = Array.isArray(nodeIds) ? nodeIds : [nodeIds];

    nodeIdArray.forEach(nodeId => {
      if (this.isRootNode(nodeId) && this.toggledNodes.has(nodeId)) {
        // Prevent toggling off root nodes
        return;
      }

      if (this.toggledNodes.has(nodeId)) {
        // Node is already toggled open, close it
        this.hideChildren(nodeId);
      } else {
        // Node is toggled closed, open it
        this.showChildren(nodeId);
      }
    });

    this.updateFilteredNodesAndLinks();
  }

  isToggled(nodeId: string): boolean {
    return this.toggledNodes.has(nodeId);
  }

  isRootNode(nodeId: string): boolean {
    return !this.links.some(link => link.target === nodeId);
  }

  hideChildren(nodeId: string) {
    this.toggledNodes.delete(nodeId);
    this.links.filter(link => link.source === nodeId).forEach(link => {
      this.hideChildren(link.target);
    });
  }

  showChildren(nodeId: string) {
    this.toggledNodes.add(nodeId);
  }

  updateFilteredNodesAndLinks() {
    const toggledNodeIds = Array.from(this.toggledNodes);

    // Set of nodes to display
    const visibleNodeIds = new Set<string>();

    // Include all toggled nodes (root nodes initially)
    toggledNodeIds.forEach(nodeId => {
      visibleNodeIds.add(nodeId);
      // Include children if node is toggled
      this.links.forEach(link => {
        if (link.source === nodeId) {
          visibleNodeIds.add(link.target);
        }
      });
    });

    // Filter nodes to include only those in visibleNodeIds
    this.filteredNodes = this.nodes.filter(node => visibleNodeIds.has(node['id']));

    // Filter links to include only those where both source and target are in visibleNodeIds
    this.filteredLinks = this.links.filter(link =>
      visibleNodeIds.has(link.source) && visibleNodeIds.has(link.target)
    );
  }

  changeOrientation() {
    console.log("this.isVertical", this.isVertical);
    this.isVertical = !this.isVertical;
    this.layoutSettings = {
      orientation: this.isVertical ? 'TB' : 'LR'
    };
  }

  addClassification() {
    this.showModal = true;
  }

  resetValues() {
    this.selectedTerm = '';
    this.newClassificationCode = '';
    this.newClassificationValue = '';
  }

  async saveClassification() {
    let di_id_of_term;

    console.log('Selected Term:', this.selectedTerm);
    console.log('Entered Code:', this.newClassificationCode);
    console.log('Entered Value:', this.newClassificationValue);
    console.log('Selected Type:', this.selectedType);

    for (const item of this.termsData) {
      if (item['di_tech_nm'] == this.selectedTerm) {
        di_id_of_term = item['di_id'];
        break;
      }
    }

    console.log('Selected Term Id:', di_id_of_term);

    let obj = {
      "id": this.authobj,
      "operation": "insert",
      "app_cd": "DD",
      "from": {
        "schema": "dd",
        "table": "cl"
      },
      "columns": ["di_id", "cl_cd", "cl_val", "cl_tcd", "cl_tcd_json"],
      "values": [di_id_of_term, this.newClassificationCode, this.newClassificationValue, this.selectedType, {}]
    }
    try {
      const data = await this.mainService.insert(obj).toPromise();
      // console.log("data", data);
      if (data['error'] === false) {
        // console.log("no error", data['data']);
        Swal.fire('Saved!', '', 'success');
        await this.getHierarchy();
      } else {
        // console.log("error", data['data']);
        Swal.fire('Error!', '', 'error');
      }
    } catch (error) {
      console.error("Error occurred:", error);
      if (error instanceof HttpErrorResponse) {
        const errorCode = error.error?.data?.message?.original?.code;
        // console.log("errorCode", errorCode);
        if (errorCode === 'ER_DUP_ENTRY') {
          Swal.fire('Error!', 'Duplicate entry detected!', 'error');
        } else {
          Swal.fire('Error!', '', 'error');
        }
      } else {
        Swal.fire('Error!', '', 'error');
      }
    }

    this.showModal = false;
    this.resetValues();
  }

  cancel() {
    this.showModal = false;
  }

  getChevronIcon(nodeId: string): string {
    if (this.isVertical) {
      return this.isToggled(nodeId) ? 'remove' : 'add';
    } else {
      return this.isToggled(nodeId) ? 'remove' : 'add';
    }
  }

  getButtonClass(nodeId: string): string {
    if (this.isVertical) {
      return this.isToggled(nodeId) ? 'chevron-left' : 'chevron-right';
    } else {
      return this.isToggled(nodeId) ? 'expand-less' : 'expand-more';
    }
  }

  calculateSecondForeignObjectX(node: any): number {
    if (!node.isRoot)
      return 100;
    else
      return 100;
  }

  calculateSecondForeignObjectY(node: any): number {
    return 0;
  }

  onMouseDown(event: MouseEvent, node: any) {
    this.dragStartTimeout = setTimeout(() => {
      this.onDragStart(node, 'graph');
      this.isDragging = true;
      this.offsetX = event.clientX;
      this.offsetY = event.clientY;
      console.log(`MouseDown - Node: ${node['id']}, OffsetX: ${this.offsetX}, OffsetY: ${this.offsetY}`);
    }, 200);
  }

  onMouseUp(event: MouseEvent, node: any) {
    this.handleMouseUp(event, node);
  }

  onMouseUpGlobal(event: MouseEvent) {
    this.handleMouseUp(event, null);
  }

  handleMouseUp(event: MouseEvent, node: any) {
    clearTimeout(this.dragStartTimeout);

    if (this.isDragging) {
      const elementUnderCursor = document.elementFromPoint(event.clientX, event.clientY) as HTMLElement;
      console.log('Mouse coordinates:', event.clientX, event.clientY);

      if (elementUnderCursor && elementUnderCursor.closest('.node')) {
        const targetNode = this.getNodeFromElement(elementUnderCursor.closest('.node'));
        if (targetNode && (this.currentNode.id != targetNode.id)) {
          console.log('MouseUp - Target node:', targetNode.id);
          this.onDrop(event, targetNode, 'graph');
        }
      }
      this.isDragging = false;
      this.currentNode = {};
    } else {
      console.log('MouseUp - Node clicked:', node['id']);
    }
  }

  onMouseMove(event: MouseEvent) {
    if (this.isDragging && this.currentNode) {
      const newX = event.clientX - this.offsetX;
      const newY = event.clientY - this.offsetY;
      this.updateNodePosition(this.currentNode, newX, newY);
    }
  }

  getNodeFromElement(element: HTMLElement | null): any {
    if (!element) return null;
    const nodeId = element.getAttribute('data-node-id');
    console.log('getNodeFromElement - Node ID:', nodeId);
    return this.nodes.find(node => node['id'] === nodeId);
  }

  updateNodePosition(node: any, x: number, y: number) {
    node.x = x;
    node.y = y;
  }
  goBack() {
    this.location.back();
  }

}